import styled from 'styled-components';

export const Container = styled.div.attrs({
  className: 'content'
})``;

export const ModalContainer = styled(Container)`
  justify-content: space-between;
  align-items: center;
  button {
    width: 100%;
  }
`;

export const OutlinedInputContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 12px 0 24px;
`
